module.exports = __webpack_public_path__ + "static/img/saoma.5dd0eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/saoma.png
// module id = niSZ
// module chunks = 171